module.exports = __webpack_public_path__ + "assets_app/img/key-correction.1151751e.svg";